class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!customElements.get("cart-remove-button")) {
  customElements.define("cart-remove-button", CartRemoveButton);
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    if (document.querySelector(".cart-shipping")) {
      this.initCartShipping();
    }

    if (document.querySelector(".cart-drawer__recommended")) {
      this.initTabsRecommendedProducts();
    }

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  initCartShipping() {
    const cartShippingEl = document.querySelector(".cart-shipping");
    if (!cartShippingEl) return;

    let progressPrev = getComputedStyle(
      cartShippingEl.querySelector(".cart-shipping__progress-current")
    )?.getPropertyValue("width");
    cartShippingEl.style.setProperty("--progress-prev", progressPrev);

    const total = cartShippingEl.dataset.total;
    const minSpend = cartShippingEl.dataset.minSpend;
    const messageTemplate = cartShippingEl.dataset.message;

    const minTotal = Math.round(minSpend * (Shopify.currency.rate || 1));
    let progress = (total / minTotal) * 100;

    if (progress > 100) progress = 100;

    if (minTotal > total) {
      let amount = minTotal - total;
      let message = messageTemplate.replace("[amount]", formatMoney(amount));
      cartShippingEl.querySelector(
        ".cart-shipping__message_default"
      ).innerHTML = message;
      cartShippingEl
        .querySelector(".cart-shipping__message_success")
        .classList.remove("active");
      cartShippingEl
        .querySelector(".cart-shipping__message_default")
        .classList.add("active");
      cartShippingEl
        .querySelector(".cart-shipping__progress")
        .classList.remove("cart-shipping__progress--success");
    } else {
      cartShippingEl
        .querySelector(".cart-shipping__message_default")
        .classList.remove("active");
      cartShippingEl
        .querySelector(".cart-shipping__message_success")
        .classList.add("active");
      cartShippingEl
        .querySelector(".cart-shipping__progress")
        .classList.add("cart-shipping__progress--success");
    }

    cartShippingEl.querySelector(
      ".cart-shipping__progress-current"
    ).style.width = progress + "%";
  }

  initTabsRecommendedProducts() {
    const wrapperEl = document.querySelector(".cart-drawer__recommended");
    if (!wrapperEl) return;

    const tabsEl = wrapperEl.querySelectorAll(".cart-drawer__recommended-tab");
    const listEl = wrapperEl.querySelectorAll(".cart-drawer__recommended-list");

    const onClickTab = (event) => {
      event.preventDefault();
      const tab = event.currentTarget;
      if (
        tab.classList.contains("active") ||
        !tab.classList.contains("cart-drawer__recommended-tab")
      ) {
        return;
      }
      const tabIndex = tab.dataset.index;
      tabsEl.forEach((el) => {
        el.classList.remove("active");
      });
      tab.classList.add("active");
      listEl.forEach((el) => {
        el.classList.remove("active");
        const listIndex = el.dataset.index;
        if (listIndex === tabIndex) {
          el.classList.add("active");
        }
      });
    };

    tabsEl.forEach((tab) => {
      tab.addEventListener("click", onClickTab);
    });
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents-totals",
      },
      {
        id: "main-cart-shipping",
        section:
          document.getElementById("main-cart-shipping")?.dataset.id || null,
        selector: ".js-contents-shipping",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll(".quantity__button").forEach((button) =>
      button.classList.add("disabled")
    );

    if (
      document.querySelectorAll(
        '.card--product card__add-to-cart button[name="add"]'
      )
    ) {
      document
        .querySelectorAll(
          '.card--product .card__add-to-cart button[name="add"], .card--product .card__link--add-to-cart_show'
        )
        .forEach((button) => {
          button.setAttribute("aria-disabled", false);
          button.removeAttribute("disabled");
          if (button.querySelector("span")) {
            button.querySelector("span").classList.remove("hidden");
            button.querySelector(".sold-out-message")?.classList.add("hidden");
          }
        });
    }

    if (document.querySelector(".cart-shipping__progress")) {
      let progressPrev = getComputedStyle(
        document.querySelector(".cart-shipping__progress-current")
      ).getPropertyValue("width");
      document.documentElement.style.setProperty(
        "--progress-prev",
        progressPrev
      );
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender()
        .filter((section) => section.section)
        .map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter) {
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        }
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
        }

        this.getSectionsToRender()
          .filter((section) => section.section)
          .forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                ?.querySelector(section.selector) ||
              document.getElementById(section.id);
            if (elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".cart-drawer__empty"),
            cartDrawerWrapper.querySelector("a")
          );
          if (cartDrawerWrapper.querySelector(".cart-drawer__recommended")) {
            this.initTabsRecommendedProducts();
            try {
              colorSwatches();
            } catch (err) {}
          }
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch((error) => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errors) errors.textContent = window.cartStrings.error;
        console.error("There was a problem with the fetch operation:", error);
      })
      .finally(() => {
        this.querySelectorAll(".quantity__button").forEach((button) =>
          button.classList.remove("disabled")
        );
        if (document.querySelector(".cart-shipping")) {
          this.initCartShipping();
        }
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items");
    if (mainCartItems) {
      const cartItemTotalsEl = this.querySelectorAll(
        `#CartItem-${line} .cart-item__totals`
      );
      const cartItemLoadingEl = this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      );

      cartItemTotalsEl.forEach((el) => el.classList.add("loading"));
      cartItemLoadingEl.forEach((overlay) =>
        overlay.classList.remove("hidden")
      );
    }

    const cartDrawer = document.getElementById("CartDrawer");
    if (cartDrawer) {
      const cartDrawerItemEl = this.querySelector(`#CartDrawer-Item-${line}`);
      const loadingEl = cartDrawerItemEl.querySelector(".loading-overlay");

      cartDrawerItemEl.classList.add("loading");
      loadingEl.classList.remove("hidden");
    }

    const totalsSubtotal = document.querySelector(".totals__subtotal-value");
    if (totalsSubtotal) {
      totalsSubtotal.classList.add("loading");
      const loadingEl = totalsSubtotal.querySelector(".loading-overlay");
      loadingEl.classList.remove("hidden");
    }

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items");
    if (mainCartItems) {
      const cartItemTotalsEl = this.querySelectorAll(
        `#CartItem-${line} .cart-item__totals`
      );
      const cartItemLoadingEl = this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      );

      cartItemTotalsEl.forEach((el) => el.classList.remove("loading"));
      cartItemLoadingEl.forEach((overlay) => overlay.classList.add("hidden"));
    }

    const cartDrawer = document.getElementById("CartDrawer");
    if (cartDrawer) {
      const cartDrawerItemEl = this.querySelector(`#CartDrawer-Item-${line}`);
      const loadingEl = cartDrawerItemEl.querySelector(".loading-overlay");

      cartDrawerItemEl.classList.remove("loading");
      loadingEl.classList.add("hidden");
    }

    const totalsSubtotal = document.querySelector(".totals__subtotal-value");
    if (totalsSubtotal) {
      totalsSubtotal.classList.remove("loading");
      const loadingEl = totalsSubtotal.querySelector(".loading-overlay");
      loadingEl.classList.add("hidden");
    }
  }
}

if (!customElements.get("cart-items")) {
  customElements.define("cart-items", CartItems);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector(".header-wrapper");
    if (this.header) this.header.preventHide = false;

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this, false)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      if (!this.classList.contains("active")) {
        this.open(cartLink);
      } else {
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if (this.header) {
      this.header.preventHide = true;
      this.header.preventReveal = true;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const search = document.querySelector("header-search.header-search");
    if (search) search.close();

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this.classList.add("active");

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".cart-drawer__empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".cart-drawer__inner") ||
          this.querySelector(".cart-drawer__header-close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden-drawer");
  }

  close() {
    this.classList.remove("active");

    if (this.activeElement) {
      const productCard = this.activeElement.closest(
        ".collection-product-card"
      );
      const productCardLink = productCard?.querySelector(
        ".card-wrapper__link--overlay"
      );
      if (productCardLink) {
        removeTrapFocus(productCardLink);
      } else {
        removeTrapFocus(this.activeElement);
      }
    }

    document.body.classList.remove("overflow-hidden-drawer");

    if (this.header) {
      this.header.preventHide = false;
      this.header.preventReveal = false;
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log('[renderContents] 🚀 STARTING - renderContents called');
    console.log('[renderContents] 📥 Received parsedState:', parsedState);
    console.log('[renderContents] 📥 Sections in parsedState:', Object.keys(parsedState.sections || {}));
    
    // DEBUG: Check current DOM state BEFORE rendering
    console.log('[renderContents] 🔍 DOM State BEFORE rendering:');
    console.log('[renderContents]   - cart-drawer classes:', this.className);
    console.log('[renderContents]   - cart-drawer has is-empty?', this.classList.contains('is-empty'));
    
    const cartDrawerInnerBefore = this.querySelector('.cart-drawer__inner');
    console.log('[renderContents]   - cart-drawer__inner has is-empty?', cartDrawerInnerBefore?.classList.contains('is-empty'));
    
    const cartDrawerEmptyBefore = this.querySelector('.cart-drawer__empty');
    console.log('[renderContents]   - cart-drawer__empty exists?', !!cartDrawerEmptyBefore);
    console.log('[renderContents]   - cart-drawer__empty display:', cartDrawerEmptyBefore?.style.display || window.getComputedStyle(cartDrawerEmptyBefore || document.body).display);
    
    const cartDrawerItemsBefore = this.querySelector('cart-drawer-items');
    console.log('[renderContents]   - cart-drawer-items has is-empty?', cartDrawerItemsBefore?.classList.contains('is-empty'));
    
    this.productId = parsedState.id;
    
    // DEBUG: Log sections being rendered
    const sectionsToUpdate = this.getSectionsToRender();
    console.log('[renderContents] 📝 Sections to render:', sectionsToUpdate.map(s => s.id));
    
    sectionsToUpdate.forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      
      console.log(`[renderContents] 🔄 Processing section: ${section.id}`);
      console.log(`[renderContents]   - Element found?`, !!sectionElement);
      console.log(`[renderContents]   - Has data?`, !!parsedState.sections[section.id]);
      
      if (sectionElement && parsedState.sections[section.id]) {
        console.log(`[renderContents]   - ✅ Updating section ${section.id}`);
        const newHtml = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
        console.log(`[renderContents]   - New HTML length:`, newHtml?.length);
        console.log(`[renderContents]   - New HTML preview:`, newHtml?.substring(0, 300));
        sectionElement.innerHTML = newHtml;
      } else {
        console.warn(`[renderContents]   - ⚠️ Skipping section ${section.id} - element:${!!sectionElement}, data:${!!parsedState.sections[section.id]}`);
      }
    });

    // CRITICAL: Remove is-empty class from all cart-related elements AFTER rendering
    // This ensures the classes are removed even if the server-rendered HTML has them
    setTimeout(() => {
      console.log('[renderContents] 🧹 CLEANUP PHASE - Removing is-empty classes and hiding empty messages');
      
      // Remove from main cart-drawer element
      const hadIsEmpty = this.classList.contains("is-empty");
      this.classList.remove("is-empty");
      console.log('[renderContents]   - cart-drawer had is-empty?', hadIsEmpty, '→ removed');
      
      // Remove from cart-drawer__inner
      const cartDrawerInner = this.querySelector(".cart-drawer__inner");
      if (cartDrawerInner) {
        const hadIsEmptyInner = cartDrawerInner.classList.contains("is-empty");
        cartDrawerInner.classList.remove("is-empty");
        console.log('[renderContents]   - cart-drawer__inner had is-empty?', hadIsEmptyInner, '→ removed');
      }
      
      // Remove from cart-drawer-items
      const cartDrawerItems = this.querySelector("cart-drawer-items");
      if (cartDrawerItems) {
        const hadIsEmptyItems = cartDrawerItems.classList.contains("is-empty");
        cartDrawerItems.classList.remove("is-empty");
        console.log('[renderContents]   - cart-drawer-items had is-empty?', hadIsEmptyItems, '→ removed');
      }
      
      // Hide all empty message containers
      const cartDrawerEmpty = this.querySelector(".cart-drawer__empty");
      if (cartDrawerEmpty) {
        const currentDisplay = window.getComputedStyle(cartDrawerEmpty).display;
        console.log('[renderContents]   - cart-drawer__empty found, current display:', currentDisplay);
        cartDrawerEmpty.style.display = "none";
        console.log('[renderContents]   - ✅ cart-drawer__empty hidden (display: none)');
      } else {
        console.log('[renderContents]   - ℹ️ cart-drawer__empty not found in DOM');
      }
      
      const cartEmpty = this.querySelector(".cart__empty");
      if (cartEmpty) {
        const currentDisplay = window.getComputedStyle(cartEmpty).display;
        console.log('[renderContents]   - cart__empty found, current display:', currentDisplay);
        cartEmpty.style.display = "none";
        console.log('[renderContents]   - ✅ cart__empty hidden (display: none)');
      } else {
        console.log('[renderContents]   - ℹ️ cart__empty not found in DOM');
      }
      
      // Make sure cart contents are visible
      const cartContents = this.querySelector(".cart__contents");
      if (cartContents) {
        cartContents.classList.remove("critical-hidden");
        cartContents.style.display = "";
        console.log('[renderContents]   - ✅ cart__contents made visible');
      }
      
      const cartDrawerContents = this.querySelector(".cart-drawer__contents");
      if (cartDrawerContents) {
        cartDrawerContents.style.display = "";
        console.log('[renderContents]   - ✅ cart-drawer__contents made visible');
      }
      
      // DEBUG: Final state check
      console.log('[renderContents] 🔍 DOM State AFTER cleanup:');
      console.log('[renderContents]   - cart-drawer has is-empty?', this.classList.contains('is-empty'));
      console.log('[renderContents]   - cart-drawer__inner has is-empty?', cartDrawerInner?.classList.contains('is-empty'));
      console.log('[renderContents]   - cart-drawer-items has is-empty?', cartDrawerItems?.classList.contains('is-empty'));
      console.log('[renderContents]   - cart-drawer__empty display:', cartDrawerEmpty?.style.display);
      console.log('[renderContents]   - cart__empty display:', cartEmpty?.style.display);
      
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this, false)
      );
      this.open();
      console.log('[renderContents] ✅ Cart drawer opened');
    }, 10);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".cart-drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

if (!customElements.get("cart-drawer-items")) {
  customElements.define("cart-drawer-items", CartDrawerItems);
}

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.spinnerIcon = this.querySelector(".cart__note-loading");
    this.successIcon = this.querySelector(".cart__note-success");
    this.textarea = this.querySelector("textarea");
    this.cartButtons = document.querySelector(".cart__ctas");
    this.drawerButtons = document.querySelector(".cart-drawer__buttons");

    this.textarea.addEventListener(
      "input",
      debounce((event) => {
        if (this.spinnerIcon) this.spinnerIcon.style.display = "flex";
        if (this.successIcon) this.successIcon.style.display = "none";
        if (this.cartButtons) this.cartButtons.style.pointerEvents = "none";
        if (this.cartButtons) this.cartButtons.style.opacity = "0.7";
        if (this.drawerButtons) this.drawerButtons.style.pointerEvents = "none";
        if (this.drawerButtons) this.drawerButtons.style.opacity = "0.7";

        const body = JSON.stringify({ note: event.target.value });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            if (this.successIcon) this.successIcon.style.display = "flex";

            setTimeout(() => {
              if (this.successIcon) this.successIcon.style.display = "none";
            }, 2000);
          })
          .catch((error) => {
            console.error(
              "There was a problem with the fetch operation:",
              error
            );
          })
          .finally(() => {
            if (this.spinnerIcon) this.spinnerIcon.style.display = "none";
            if (this.cartButtons) this.cartButtons.removeAttribute("style");
            if (this.drawerButtons) this.drawerButtons.removeAttribute("style");
          });
      }, 500)
    );
  }
}

if (!customElements.get("cart-note")) {
  customElements.define("cart-note", CartNote);
}

// Global cart event listener for external apps (Quiz apps, etc.)
// This intercepts cart API calls and opens the drawer automatically
(function() {
  console.log('🚀🚀🚀 [CART INTERCEPTOR] Initializing... This log should appear immediately on page load!');
  
  // Track if page has finished loading to avoid opening drawer on initial page load
  let pageLoadComplete = false;
  let drawerAlreadyOpened = false; // Track if we already opened drawer to prevent double-opening
  let cartOperationDuringLoad = false; // Track if cart operation happened before page load
  
  window.addEventListener('load', () => {
    // Add a small delay after page load to avoid catching any initial cart sync operations
    setTimeout(() => {
      pageLoadComplete = true;
      console.log('[CART INTERCEPTOR] ✅ Page load complete - drawer will now open on cart operations');
      
      // DISABLED: Auto-open on page load removed per user request
      // Cart will only open when user manually adds/removes items
      if (false && cartOperationDuringLoad) {
        console.log('[CART INTERCEPTOR] 🔍 Cart operation was detected during page load - checking cart state');
        
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            console.log('[CART INTERCEPTOR] 🔍 Cart item count:', cart.item_count);
            
            if (cart.item_count > 0) {
              console.log('[CART INTERCEPTOR] 🎯 Opening drawer for skipped cart operation...');
            
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              const pageUrl = window.Shopify?.routes?.root || '/';
              
              fetch(pageUrl)
                .then(res => res.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newCartDrawerElement = doc.querySelector('cart-drawer');
                  
                  if (newCartDrawerElement) {
                    const newCartDrawerContent = newCartDrawerElement.querySelector('#CartDrawer');
                    const currentCartDrawerContent = cartDrawer.querySelector('#CartDrawer');
                    
                    if (newCartDrawerContent && currentCartDrawerContent) {
                      // DEBUG: Analyze what we're about to inject
                      console.log('[CART DEBUG] 🔍 Analyzing fetched cart HTML:');
                      console.log('[CART DEBUG]   Current page URL:', window.location.href);
                      console.log('[CART DEBUG]   Fetched from URL:', pageUrl);
                      
                      // List ALL loaded stylesheets on current page
                      console.log('[CART DEBUG] 📑 ALL LOADED STYLESHEETS ON CURRENT PAGE:');
                      Array.from(document.styleSheets).forEach((sheet, index) => {
                        const url = sheet.href || 'inline';
                        const filename = url.split('/').pop() || 'inline';
                        console.log(`[CART DEBUG]   ${index + 1}. ${filename} | ${url}`);
                      });
                      
                      // Check for complementary products section
                      const complementarySection = newCartDrawerContent.querySelector('.cart_drawer--cp--main-wrap');
                      console.log('[CART DEBUG]   Has complementary products?', !!complementarySection);
                      
                      if (complementarySection) {
                        const cards = complementarySection.querySelectorAll('.cart_drawer--cp--list-grid');
                        console.log('[CART DEBUG]   Number of product cards:', cards.length);
                        
                        if (cards.length > 0) {
                          const firstCard = cards[0];
                          console.log('[CART DEBUG]   First card HTML length:', firstCard.innerHTML.length);
                          
                          const cardWrapper = firstCard.querySelector('.card-wrapper');
                          const card = firstCard.querySelector('.card');
                          const cardTitle = firstCard.querySelector('.card__title');
                          const cardMedia = firstCard.querySelector('.card__media, .media');
                          
                          console.log('[CART DEBUG]   Card structure:');
                          console.log('[CART DEBUG]     - Has .card-wrapper?', !!cardWrapper);
                          console.log('[CART DEBUG]     - Has .card?', !!card);
                          console.log('[CART DEBUG]     - Has .card__title?', !!cardTitle);
                          console.log('[CART DEBUG]     - Has media?', !!cardMedia);
                          
                          if (cardTitle) {
                            console.log('[CART DEBUG]     - Title text:', cardTitle.textContent?.trim().substring(0, 50));
                            console.log('[CART DEBUG]     - Title classes:', cardTitle.className);
                          }
                        }
                      }
                      
                      currentCartDrawerContent.innerHTML = newCartDrawerContent.innerHTML;
                      
                      // DEBUG: Check AFTER injection
                      console.log('[CART DEBUG] 🔍 After injection - checking current page:');
                      const currentComplementarySection = currentCartDrawerContent.querySelector('.cart_drawer--cp--main-wrap');
                      if (currentComplementarySection) {
                        const currentCards = currentComplementarySection.querySelectorAll('.cart_drawer--cp--list-grid');
                        console.log('[CART DEBUG]   Cards after injection:', currentCards.length);
                        
                        if (currentCards.length > 0) {
                          const firstCurrentCard = currentCards[0];
                          const currentCardTitle = firstCurrentCard.querySelector('.card__title');
                          
                          if (currentCardTitle) {
                            const computedStyle = window.getComputedStyle(currentCardTitle);
                            console.log('[CART DEBUG]   First card title COMPUTED STYLES:');
                            console.log('[CART DEBUG]     - font-size:', computedStyle.fontSize);
                            console.log('[CART DEBUG]     - line-height:', computedStyle.lineHeight);
                            console.log('[CART DEBUG]     - max-width:', computedStyle.maxWidth);
                            console.log('[CART DEBUG]     - width:', computedStyle.width);
                            
                            // CRITICAL: Find which CSS rule is setting the font-size
                            try {
                              const matchedRules = [];
                              for (let sheet of document.styleSheets) {
                                try {
                                  if (sheet.cssRules) {
                                    for (let rule of sheet.cssRules) {
                                      if (rule.selectorText && currentCardTitle.matches(rule.selectorText)) {
                                        if (rule.style.fontSize) {
                                          matchedRules.push({
                                            selector: rule.selectorText,
                                            fontSize: rule.style.fontSize,
                                            sheet: sheet.href || 'inline'
                                          });
                                        }
                                      }
                                    }
                                  }
                                } catch (e) {}
                              }
                              console.log('[CART DEBUG] 🎨 CSS RULES affecting .card__title font-size:', matchedRules);
                              console.log('[CART DEBUG] 🎨 DETAILED CSS RULES:');
                              matchedRules.forEach((rule, index) => {
                                console.log(`[CART DEBUG]   Rule ${index + 1}:`, rule.selector, '→ font-size:', rule.fontSize, '| from:', rule.sheet);
                              });
                            } catch (e) {
                              console.log('[CART DEBUG] Could not analyze CSS rules:', e.message);
                            }
                          }
                          
                          const currentCardWrapper = firstCurrentCard.querySelector('.card-wrapper');
                          if (currentCardWrapper) {
                            const wrapperStyle = window.getComputedStyle(currentCardWrapper);
                            console.log('[CART DEBUG]   Card wrapper COMPUTED STYLES:');
                            console.log('[CART DEBUG]     - width:', wrapperStyle.width);
                            console.log('[CART DEBUG]     - max-width:', wrapperStyle.maxWidth);
                            console.log('[CART DEBUG]     - display:', wrapperStyle.display);
                            console.log('[CART DEBUG]     - padding:', wrapperStyle.padding);
                            console.log('[CART DEBUG]     - margin:', wrapperStyle.margin);
                          }
                          
                          const currentCard = firstCurrentCard.querySelector('.card');
                          if (currentCard) {
                            const cardStyle = window.getComputedStyle(currentCard);
                            console.log('[CART DEBUG]   .card COMPUTED STYLES:');
                            console.log('[CART DEBUG]     - padding:', cardStyle.padding);
                            console.log('[CART DEBUG]     - margin:', cardStyle.margin);
                            console.log('[CART DEBUG]     - width:', cardStyle.width);
                          }
                          
                          const currentCardInfo = firstCurrentCard.querySelector('.card-information');
                          if (currentCardInfo) {
                            const infoStyle = window.getComputedStyle(currentCardInfo);
                            console.log('[CART DEBUG]   .card-information COMPUTED STYLES:');
                            console.log('[CART DEBUG]     - padding:', infoStyle.padding);
                            console.log('[CART DEBUG]     - width:', infoStyle.width);
                            
                            // Find which CSS rule is setting padding
                            try {
                              const paddingRules = [];
                              for (let sheet of document.styleSheets) {
                                try {
                                  if (sheet.cssRules) {
                                    for (let rule of sheet.cssRules) {
                                      if (rule.selectorText && currentCardInfo.matches(rule.selectorText)) {
                                        if (rule.style.padding || rule.style.paddingTop || rule.style.paddingLeft) {
                                          paddingRules.push({
                                            selector: rule.selectorText,
                                            padding: rule.style.padding || `${rule.style.paddingTop} ${rule.style.paddingRight} ${rule.style.paddingBottom} ${rule.style.paddingLeft}`,
                                            sheet: sheet.href || 'inline'
                                          });
                                        }
                                      }
                                    }
                                  }
                                } catch (e) {}
                              }
                              console.log('[CART DEBUG] 🎨 CSS RULES affecting .card-information padding:', paddingRules);
                            } catch (e) {
                              console.log('[CART DEBUG] Could not analyze padding rules:', e.message);
                            }
                          }
                          
                          // Check for overlay link
                          const overlayLink = firstCurrentCard.querySelector('.link--overlay, .card-wrapper__link--overlay');
                          console.log('[CART DEBUG]   Has overlay link?', !!overlayLink);
                          if (overlayLink) {
                            const overlayStyle = window.getComputedStyle(overlayLink);
                            console.log('[CART DEBUG]   Overlay link COMPUTED STYLES:');
                            console.log('[CART DEBUG]     - display:', overlayStyle.display);
                            console.log('[CART DEBUG]     - position:', overlayStyle.position);
                            console.log('[CART DEBUG]     - width:', overlayStyle.width);
                            console.log('[CART DEBUG]     - height:', overlayStyle.height);
                            console.log('[CART DEBUG]     - z-index:', overlayStyle.zIndex);
                          }
                        }
                      }
                      
                      const forceCleanup = () => {
                        cartDrawer.classList.remove('is-empty');
                        const cartDrawerInner = cartDrawer.querySelector('.cart-drawer__inner');
                        const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
                        if (cartDrawerInner) cartDrawerInner.classList.remove('is-empty');
                        if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
                        
                        const emptyElements = cartDrawer.querySelectorAll('.cart-drawer__empty, .cart__empty');
                        emptyElements.forEach(el => {
                          el.style.display = 'none';
                          el.style.visibility = 'hidden';
                          el.style.height = '0';
                          el.style.overflow = 'hidden';
                        });
                      };
                      
                      forceCleanup();
                      setTimeout(forceCleanup, 100);
                      setTimeout(forceCleanup, 300);
                      
                      const newCartIcon = doc.querySelector('#cart-icon-bubble');
                      const currentCartIcon = document.querySelector('#cart-icon-bubble');
                      if (newCartIcon && currentCartIcon) {
                        currentCartIcon.innerHTML = newCartIcon.innerHTML;
                      }
                      
                      const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
                      if (overlay) {
                        const newOverlay = overlay.cloneNode(true);
                        overlay.parentNode.replaceChild(newOverlay, overlay);
                        newOverlay.addEventListener("click", () => cartDrawer.close());
                      }
                      
                      const closeButton = cartDrawer.querySelector(".cart-drawer__header-close");
                      if (closeButton) {
                        closeButton.addEventListener("click", () => cartDrawer.close());
                      }
                      
                      setTimeout(() => {
                        cartDrawer.open();
                        drawerAlreadyOpened = true;
                        console.log('[CART INTERCEPTOR] ✅ Cart drawer opened after page load');
                        setTimeout(forceCleanup, 50);
                      }, 50);
                    }
                  }
                })
                .catch(error => {
                  console.error('[CART INTERCEPTOR] Error fetching cart on page load:', error);
                });
            }
            } else {
              console.log('[CART INTERCEPTOR] ℹ️ Cart is empty after skipped operation');
            }
          })
          .catch(error => {
            console.error('[CART INTERCEPTOR] Error checking cart state:', error);
          });
      } else {
        console.log('[CART INTERCEPTOR] ℹ️ No cart operation during load - not auto-opening drawer');
      }
    }, 300); // Reduced delay
  });
  
  // Store the original fetch function
  const originalFetch = window.fetch;
  
  // Override fetch to detect cart operations from external apps
  window.fetch = function(...args) {
    const url = args[0];
    const options = args[1] || {};
    
    // Check if this is a cart add/update/change request (handle both full URLs and relative paths)
    const urlString = typeof url === 'string' ? url : (url?.url || '');
    const isCartAdd = urlString.includes('/cart/add.js') || urlString.includes('cart/add');
    const isCartUpdate = urlString.includes('/cart/update.js') || urlString.includes('cart/update');
    const isCartChange = urlString.includes('/cart/change.js') || urlString.includes('cart/change');
    const isCartRequest = isCartAdd || isCartUpdate || isCartChange;
    
    // Capture if THIS request is starting during page load
    const thisRequestDuringLoad = !pageLoadComplete;
    
    // Call original fetch
    const fetchPromise = originalFetch.apply(this, args);
    
    // If it's a cart request, handle the response
    if (isCartRequest && options.method === 'POST') {
      console.log('[Cart Interceptor] Detected cart operation:', urlString);
      
      fetchPromise.then(response => {
        // Only proceed if the request was successful
        if (response.ok) {
          // Log if this was a page-load operation
          if (thisRequestDuringLoad) {
            console.log('[Cart Interceptor] ⏸️ Cart operation started during page load - will update but not auto-open');
          }
          
          // Don't open if we already opened it after page load (prevents double-opening on Quiz page)
          if (drawerAlreadyOpened) {
            console.log('[Cart Interceptor] ⏸️ Skipping drawer open - already opened after page load');
            drawerAlreadyOpened = false; // Reset for future operations
            return response;
          }
          
          console.log('[Cart Interceptor] Cart operation successful, updating cart...');
          
          // Clone the response so we don't consume it
          response.clone().json().then(data => {
            console.log('[Cart Interceptor] ✅ Response parsed successfully');
            // Longer delay to ensure server has updated the cart state
            setTimeout(() => {
              const cartDrawer = document.querySelector('cart-drawer');
              
              if (cartDrawer) {
                // Fetch updated cart sections
                const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
                const sectionsParam = sectionsToRender.join(',');
                
                // Use Shopify routes if available, otherwise use root path
                const rootPath = window.Shopify?.routes?.root || '/';
                const cartUrl = `${rootPath}cart?sections=${sectionsParam}`;
                
                console.log('[Cart Interceptor] Fetching cart sections from:', cartUrl);
                
                // WORKAROUND: Section rendering returns empty sections
                // Instead, reload the entire page's cart drawer by fetching it fresh
                console.log('[Cart Interceptor] ⚠️ Using page reload workaround due to empty sections issue');
                
                // CRITICAL FIX: Always fetch from homepage, not Quiz page
                const pageUrl = window.Shopify?.routes?.root || '/';
                console.log('[Cart Interceptor] 📍 Fetching cart HTML from:', pageUrl);
                
                fetch(pageUrl)
                  .then(res => res.text())
                  .then(html => {
                    console.log('[Cart Interceptor] 📄 Page HTML fetched successfully');
                    
                    // Parse the HTML
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    
                    // Extract the cart drawer HTML from the fetched page
                    const newCartDrawerElement = doc.querySelector('cart-drawer');
                    
                    if (newCartDrawerElement) {
                      console.log('[Cart Interceptor] ✅ Found cart-drawer in page HTML');
                      
                      // Get the innerHTML of #CartDrawer (the actual drawer content)
                      const newCartDrawerContent = newCartDrawerElement.querySelector('#CartDrawer');
                      const currentCartDrawerContent = cartDrawer.querySelector('#CartDrawer');
                      
                      if (newCartDrawerContent && currentCartDrawerContent) {
                        console.log('[Cart Interceptor] 🔄 Replacing cart drawer content');
                        
                        // DEBUG: Same analysis for regular interceptor
                        console.log('[CART DEBUG 2] 🔍 Analyzing fetched cart HTML (regular interceptor):');
                        const complementarySection2 = newCartDrawerContent.querySelector('.cart_drawer--cp--main-wrap');
                        if (complementarySection2) {
                          const cards2 = complementarySection2.querySelectorAll('.cart_drawer--cp--list-grid .card__title');
                          console.log('[CART DEBUG 2]   Product card titles found:', cards2.length);
                          if (cards2.length > 0) {
                            console.log('[CART DEBUG 2]   First title text:', cards2[0].textContent?.trim().substring(0, 50));
                          }
                        }
                        
                        currentCartDrawerContent.innerHTML = newCartDrawerContent.innerHTML;
                        
                        // DEBUG: Check styles AFTER injection on Quiz page
                        setTimeout(() => {
                          const afterCards = currentCartDrawerContent.querySelectorAll('.cart_drawer--cp--list-grid .card__title');
                          if (afterCards.length > 0) {
                            const titleElement = afterCards[0];
                            const style = window.getComputedStyle(titleElement);
                            console.log('[CART DEBUG 2] 📏 After injection font-size:', style.fontSize);
                            console.log('[CART DEBUG 2] 📏 After injection line-height:', style.lineHeight);
                            
                            // Check what CSS rules are being applied
                            console.log('[CART DEBUG 2] 🎨 Checking active stylesheets on Quiz page:');
                            const sheets = Array.from(document.styleSheets);
                            const quizSheets = sheets.filter(s => s.href && (s.href.includes('quiz') || s.href.includes('Quiz')));
                            console.log('[CART DEBUG 2]   Quiz-specific stylesheets:', quizSheets.map(s => s.href));
                            
                            // Check inline styles
                            const inlineStyle = titleElement.getAttribute('style');
                            console.log('[CART DEBUG 2]   Inline style on title:', inlineStyle || 'none');
                            
                            // Check parent containers
                            console.log('[CART DEBUG 2]   Parent chain:');
                            let parent = titleElement.parentElement;
                            let depth = 0;
                            while (parent && depth < 5) {
                              console.log(`[CART DEBUG 2]     ${depth}: ${parent.tagName}.${parent.className}`);
                              parent = parent.parentElement;
                              depth++;
                            }
                          }
                        }, 100);
                        
                        // Aggressive cleanup function
                        const forceCleanup = () => {
                          console.log('[Cart Interceptor] 🧹 Running aggressive cleanup');
                          
                          // Remove ALL is-empty classes
                          cartDrawer.classList.remove('is-empty');
                          const cartDrawerInner = cartDrawer.querySelector('.cart-drawer__inner');
                          const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
                          if (cartDrawerInner) cartDrawerInner.classList.remove('is-empty');
                          if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
                          
                          // Hide ALL empty message elements
                          const emptyElements = cartDrawer.querySelectorAll('.cart-drawer__empty, .cart__empty');
                          emptyElements.forEach(el => {
                            el.style.display = 'none';
                            el.style.visibility = 'hidden';
                            el.style.height = '0';
                            el.style.overflow = 'hidden';
                          });
                          
                          if (emptyElements.length > 0) {
                            console.log('[Cart Interceptor] 🚫 Hidden', emptyElements.length, 'empty message elements');
                          }
                        };
                        
                        // Run cleanup immediately
                        forceCleanup();
                        
                        // Run cleanup again after a short delay (in case elements are added dynamically)
                        setTimeout(forceCleanup, 100);
                        setTimeout(forceCleanup, 300);
                        
                        // Update cart icon
                        const newCartIcon = doc.querySelector('#cart-icon-bubble');
                        const currentCartIcon = document.querySelector('#cart-icon-bubble');
                        if (newCartIcon && currentCartIcon) {
                          currentCartIcon.innerHTML = newCartIcon.innerHTML;
                          console.log('[Cart Interceptor] 🔄 Updated cart icon bubble');
                        }
                        
                        // Re-attach event handlers (destroyed when we replaced innerHTML)
                        const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
                        if (overlay) {
                          // Remove any existing listeners first
                          const newOverlay = overlay.cloneNode(true);
                          overlay.parentNode.replaceChild(newOverlay, overlay);
                          
                          // Add the click handler
                          newOverlay.addEventListener("click", () => {
                            console.log('[Cart Interceptor] Overlay clicked - closing drawer');
                            cartDrawer.close();
                          });
                          console.log('[Cart Interceptor] ✅ Re-attached overlay click handler');
                        }
                        
                        // Re-attach close button handler
                        const closeButton = cartDrawer.querySelector(".cart-drawer__header-close");
                        if (closeButton) {
                          closeButton.addEventListener("click", () => {
                            console.log('[Cart Interceptor] Close button clicked');
                            cartDrawer.close();
                          });
                          console.log('[Cart Interceptor] ✅ Re-attached close button handler');
                        }
                        
                        // Open the drawer (with special handling for Quiz page)
                        setTimeout(() => {
                          if (!thisRequestDuringLoad) {
                            // Check if on Quiz page
                            const isQuizPage = window.location.pathname.includes('שאלון') || 
                                             window.location.pathname.includes('%D7%A9%D7%90%D7%9C%D7%95%D7%9F');
                            
                            if (isQuizPage) {
                              // On Quiz page: verify cart has items before opening
                              fetch('/cart.js')
                                .then(res => res.json())
                                .then(cart => {
                                  if (cart.item_count > 0) {
                                    cartDrawer.open();
                                    console.log('[Cart Interceptor] ✅ Cart drawer opened (Quiz page, has items)');
                                  } else {
                                    console.log('[Cart Interceptor] ℹ️ Cart empty - not opening (Quiz page)');
                                  }
                                })
                                .catch(error => {
                                  console.error('[Cart Interceptor] Error checking cart count:', error);
                                });
                            } else {
                              // Other pages: open normally
                              cartDrawer.open();
                              console.log('[Cart Interceptor] ✅ Cart drawer opened');
                            }
                          } else {
                            console.log('[Cart Interceptor] ℹ️ Cart updated but not opened (request was during page load)');
                          }
                          
                          // Final cleanup
                          setTimeout(forceCleanup, 50);
                        }, 50);
                      }
                    } else {
                      console.error('[Cart Interceptor] ❌ Could not find cart-drawer in fetched page');
                    }
                  })
                  .catch(error => {
                    console.error('[Cart Interceptor] Error fetching cart sections:', error);
                  });
              } else {
                console.warn('[Cart Interceptor] Cart drawer element not found');
              }
            }, 400);
          }).catch(error => {
            // Handle non-JSON responses (still need to update cart)
            console.log('[Cart Interceptor] Response was not JSON, updating cart anyway...');
            
            setTimeout(() => {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                const pageUrl = window.Shopify?.routes?.root || '/';
                
                fetch(pageUrl)
                  .then(res => res.text())
                  .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newCartDrawerElement = doc.querySelector('cart-drawer');
                    
                    if (newCartDrawerElement) {
                      const newCartDrawerContent = newCartDrawerElement.querySelector('#CartDrawer');
                      const currentCartDrawerContent = cartDrawer.querySelector('#CartDrawer');
                      
                      if (newCartDrawerContent && currentCartDrawerContent) {
                        currentCartDrawerContent.innerHTML = newCartDrawerContent.innerHTML;
                        
                        // Cleanup
                        const forceCleanup = () => {
                          cartDrawer.classList.remove('is-empty');
                          const cartDrawerInner = cartDrawer.querySelector('.cart-drawer__inner');
                          const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
                          if (cartDrawerInner) cartDrawerInner.classList.remove('is-empty');
                          if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
                          
                          const emptyElements = cartDrawer.querySelectorAll('.cart-drawer__empty, .cart__empty');
                          emptyElements.forEach(el => {
                            el.style.display = 'none';
                            el.style.visibility = 'hidden';
                            el.style.height = '0';
                            el.style.overflow = 'hidden';
                          });
                        };
                        
                        forceCleanup();
                        setTimeout(forceCleanup, 100);
                        setTimeout(forceCleanup, 300);
                        
                        // Update cart icon
                        const newCartIcon = doc.querySelector('#cart-icon-bubble');
                        const currentCartIcon = document.querySelector('#cart-icon-bubble');
                        if (newCartIcon && currentCartIcon) {
                          currentCartIcon.innerHTML = newCartIcon.innerHTML;
                        }
                        
                        // Re-attach event handlers
                        const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
                        if (overlay) {
                          const newOverlay = overlay.cloneNode(true);
                          overlay.parentNode.replaceChild(newOverlay, overlay);
                          newOverlay.addEventListener("click", () => cartDrawer.close());
                        }
                        
                        const closeButton = cartDrawer.querySelector(".cart-drawer__header-close");
                        if (closeButton) {
                          closeButton.addEventListener("click", () => cartDrawer.close());
                        }
                        
                        // Open drawer (with special handling for Quiz page)
                        setTimeout(() => {
                          if (!thisRequestDuringLoad) {
                            // Check if on Quiz page
                            const isQuizPage = window.location.pathname.includes('שאלון') || 
                                             window.location.pathname.includes('%D7%A9%D7%90%D7%9C%D7%95%D7%9F');
                            
                            if (isQuizPage) {
                              // On Quiz page: verify cart has items before opening
                              fetch('/cart.js')
                                .then(res => res.json())
                                .then(cart => {
                                  if (cart.item_count > 0) {
                                    cartDrawer.open();
                                    console.log('[Cart Interceptor] ✅ Cart drawer opened (Quiz page, has items, non-JSON)');
                                  } else {
                                    console.log('[Cart Interceptor] ℹ️ Cart empty - not opening (Quiz page, non-JSON)');
                                  }
                                });
                            } else {
                              // Other pages: open normally
                              cartDrawer.open();
                              console.log('[Cart Interceptor] ✅ Cart drawer opened (non-JSON response)');
                            }
                          } else {
                            console.log('[Cart Interceptor] ℹ️ Cart updated but not opened (non-JSON, request was during page load)');
                          }
                          setTimeout(forceCleanup, 50);
                        }, 50);
                      }
                    }
                  })
                  .catch(error => {
                    console.error('[Cart Interceptor] Error updating cart from non-JSON response:', error);
                  });
              }
            }, 400);
          });
        }
      }).catch(error => {
        // Let errors propagate naturally
        console.error('[Cart Interceptor] Cart fetch error:', error);
      });
    }
    
    return fetchPromise;
  };
  
  console.log('✅ [CART INTERCEPTOR] Fetch interceptor installed');
  
  // ALSO intercept XMLHttpRequest for apps that don't use fetch
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._method = method;
    this._url = url;
    // Only log cart-related requests to avoid console spam
    if (url && (url.includes('/cart/') || url.includes('cart.js'))) {
      console.log('[XHR INTERCEPTOR] 📡 XHR.open called:', method, url);
    }
    return originalXHROpen.apply(this, [method, url, ...rest]);
  };
  
  XMLHttpRequest.prototype.send = function(...args) {
    const xhr = this;
    const url = xhr._url || '';
    const method = xhr._method || '';
    
    const isCartAdd = url.includes('/cart/add.js') || url.includes('cart/add');
    const isCartUpdate = url.includes('/cart/update.js') || url.includes('cart/update');
    const isCartChange = url.includes('/cart/change.js') || url.includes('cart/change');
    const isCartRequest = isCartAdd || isCartUpdate || isCartChange;
    
    if (isCartRequest && method.toUpperCase() === 'POST') {
      console.log('[XHR INTERCEPTOR] 🎯 Detected cart operation via XHR:', url);
      
      // Capture if THIS request is starting during page load
      const xhrRequestDuringLoad = !pageLoadComplete;
      
      // Listen for successful completion
      xhr.addEventListener('load', function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          console.log('[XHR INTERCEPTOR] ✅ Cart operation successful via XHR');
          
          // Log if this was a page-load operation
          if (xhrRequestDuringLoad) {
            console.log('[XHR INTERCEPTOR] ⏸️ Cart operation started during page load - will update but not auto-open');
          }
          
          setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer');
            
            if (cartDrawer) {
              console.log('[XHR INTERCEPTOR] Using page reload workaround');
              
              // Always fetch from homepage to get proper cart structure
              const pageUrl = window.Shopify?.routes?.root || '/';
              
              originalFetch(pageUrl)
                .then(res => res.text())
                .then(html => {
                  console.log('[XHR INTERCEPTOR] Page HTML fetched');
                  
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newCartDrawerElement = doc.querySelector('cart-drawer');
                  
                  if (newCartDrawerElement) {
                    const newCartDrawerContent = newCartDrawerElement.querySelector('#CartDrawer');
                    const currentCartDrawerContent = cartDrawer.querySelector('#CartDrawer');
                    
                    if (newCartDrawerContent && currentCartDrawerContent) {
                      console.log('[XHR INTERCEPTOR] Replacing cart content');
                      currentCartDrawerContent.innerHTML = newCartDrawerContent.innerHTML;
                      
                      // Aggressive cleanup
                      const forceCleanup = () => {
                        cartDrawer.classList.remove('is-empty');
                        const cartDrawerInner = cartDrawer.querySelector('.cart-drawer__inner');
                        const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
                        if (cartDrawerInner) cartDrawerInner.classList.remove('is-empty');
                        if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
                        
                        const emptyElements = cartDrawer.querySelectorAll('.cart-drawer__empty, .cart__empty');
                        emptyElements.forEach(el => {
                          el.style.display = 'none';
                          el.style.visibility = 'hidden';
                          el.style.height = '0';
                          el.style.overflow = 'hidden';
                        });
                      };
                      
                      forceCleanup();
                      setTimeout(forceCleanup, 100);
                      setTimeout(forceCleanup, 300);
                      
                      // Update cart icon
                      const newCartIcon = doc.querySelector('#cart-icon-bubble');
                      const currentCartIcon = document.querySelector('#cart-icon-bubble');
                      if (newCartIcon && currentCartIcon) {
                        currentCartIcon.innerHTML = newCartIcon.innerHTML;
                      }
                      
                      // Re-attach event handlers
                      const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
                      if (overlay) {
                        const newOverlay = overlay.cloneNode(true);
                        overlay.parentNode.replaceChild(newOverlay, overlay);
                        newOverlay.addEventListener("click", () => {
                          cartDrawer.close();
                        });
                      }
                      
                      const closeButton = cartDrawer.querySelector(".cart-drawer__header-close");
                      if (closeButton) {
                        closeButton.addEventListener("click", () => {
                          cartDrawer.close();
                        });
                      }
                      
                      // Open the drawer (with special handling for Quiz page)
                      setTimeout(() => {
                        if (!xhrRequestDuringLoad) {
                          // Check if on Quiz page
                          const isQuizPage = window.location.pathname.includes('שאלון') || 
                                           window.location.pathname.includes('%D7%A9%D7%90%D7%9C%D7%95%D7%9F');
                          
                          if (isQuizPage) {
                            // On Quiz page: verify cart has items before opening
                            fetch('/cart.js')
                              .then(res => res.json())
                              .then(cart => {
                                if (cart.item_count > 0) {
                                  cartDrawer.open();
                                  console.log('[XHR INTERCEPTOR] Cart drawer opened (Quiz page, has items)');
                                } else {
                                  console.log('[XHR INTERCEPTOR] ℹ️ Cart empty - not opening (Quiz page)');
                                }
                              })
                              .catch(error => {
                                console.error('[XHR INTERCEPTOR] Error checking cart count:', error);
                              });
                          } else {
                            // Other pages: open normally
                            cartDrawer.open();
                            console.log('[XHR INTERCEPTOR] Cart drawer opened');
                          }
                        } else {
                          console.log('[XHR INTERCEPTOR] ℹ️ Cart updated but not opened (request was during page load)');
                        }
                        setTimeout(forceCleanup, 50);
                      }, 50);
                    }
                  }
                })
                .catch(error => {
                  console.error('[XHR INTERCEPTOR] Error:', error);
                });
            }
          }, 400);
        }
      });
    }
    
    return originalXHRSend.apply(this, args);
  };
  
  console.log('✅ [CART INTERCEPTOR] XMLHttpRequest interceptor installed');
  console.log('🎉 [CART INTERCEPTOR] All interceptors ready! Watching for cart operations...');
})();
